import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import {
  CreatePlayload,
  // DecodeToken
} from "../../lib/token";
import { ablyClient } from "../../lib/socket";
// import { DashboardStatus } from "./dashboard";
const channel = ablyClient.channels.get("presence-demo");

// const GEtUserData = (payload) => {
//   const getToken = DecodeToken(payload);
//   const user = DecodeToken(getToken?.token);
//   return user;
// };
const initialState = {
  isAuthenticated: !!localStorage.getItem("c10sjuex") || false,
  user: JSON.parse(localStorage.getItem("c10sjuex")) || null,
  loading: false,
  token: null,
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    requestStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    loginSuccess: (state, action) => {
      state.isAuthenticated = true;
      state.user = action.payload;
      state.loading = false;
      state.error = null;
    },
    requestFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.isAuthenticated = false;
      state.user = null;
      state.token = null;
      localStorage.removeItem("c10sjuex");
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      state.token = null;
      localStorage.removeItem("c10sjuex");
      channel.presence.unsubscribe();
      if (channel?.state === "joined") {
        channel.presence.leave();
      }
      // channel.presence.leave();
      // channel.presence.unsubscribe();
    },
  },
});

export const { requestStart, loginSuccess, requestFailure, logout } =
  authSlice.actions;
export default authSlice.reducer;

// Login action
export const Signin = (data, navigate) => async (dispatch) => {
  try {
    dispatch(requestStart());
    const Token = CreatePlayload(CreatePlayload(data));

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/login`,
      data,
      {
        headers: {
          Authorization: `Bearer ${Token?.token}`,
        },
      },
    );

    if (response?.status === 200) {
      const user = response.data;

      if (user) {
        dispatch(loginSuccess(user));

        await channel.presence.enter(user);
        localStorage.setItem("c10sjuex", JSON.stringify(user));

        navigate("/dashboard");
        toast.success("You are successfully logged in.");
      } else {
        throw new Error("No token received");
      }
    }
  } catch (err) {
    toast.error(err?.response?.data?.message || "Login failed!");
    dispatch(
      requestFailure(err?.response?.data?.message || "Something went wrong!"),
    );
  }
};
